import {INTERVIEW_SET_CATEGORIES} from '../../../interview-v2/constants/interview.constant.js';

(function () {

var OpenDayDetailsForm = function (scope, hUser, $modal, $filter) {

    var form = this;
    var formName = "open-day-details-form";
    var _protected = BaseForm.call(form, formName, scope);

    form.NUMBER_OF_EVENTS_TO_VIEW = 2;
    form.opendayDaysOffset = 0;
    form.calendarStartDate = moment().startOf('day');

    var loadedOpenday;
    var allInterviewers = [];

    form.CUSTOM_LOCATION = {
        name: $filter("translate")("Custom"),
        google_place_id: -1
    };

    form.selectedInterviewersToAdd = {};

    form.simpleCalendarTriggers = {};

    form.INTERVIEW_SET_CATEGORIES = INTERVIEW_SET_CATEGORIES;

    form.data = {
        selectedEvents: [],
        interviewers: [],
        message: '',
        interviewCategory: form.INTERVIEW_SET_CATEGORIES.IN_PERSON,
        location: {}
    };

    form.NAVIGATIONS = {
        LEFT: 'LEFT',
        RIGHT: 'RIGHT'
    };

    var requiredApisPromise = [];

    // this promise to make sure that the critical data has been loaded before execute load function.
    var fullPromise;

    form.removeInterviewerAtIndex = function (index) {
        form.interviewers.push(form.data.interviewers.splice(index, 1)[0]);
    };

    /*
    * I used the scope because h-select doesn't accept onChange function to be like form.onSelectNewInterviewer
    * */
    scope.onSelectNewInterviewer = function (event) {

        var addedInterviewer = event.added.value;

        if (addedInterviewer && addedInterviewer.id) {

            form.data.interviewers = form.data.interviewers.concat(addedInterviewer);

            var interviewerIndex = form.interviewers.findIndex(function (interviewer) {
                return interviewer.id === addedInterviewer.id
            });

            // work around to fit with the select2 and remove the selection option
            setTimeout(function () {
                form.selectedInterviewersToAdd = {};
                scope.$digest();
            });

            form.interviewers.splice(interviewerIndex, 1);
        }
    };

    form.onNavigateDaysClicked = function (navigation) {
        switch (navigation) {
            case form.NAVIGATIONS.LEFT:

                if (form.opendayDaysOffset > 0) {
                    form.opendayDaysOffset -= form.NUMBER_OF_EVENTS_TO_VIEW;
                }

                break;
            case form.NAVIGATIONS.RIGHT:

                if (form.opendayDaysOffset + form.NUMBER_OF_EVENTS_TO_VIEW < form.data.selectedEvents.length) {
                    form.opendayDaysOffset += form.NUMBER_OF_EVENTS_TO_VIEW;
                }

                break;
        }
    };

    let getSmartFields = async () => {
        const params = {
            template_category: form.data.interviewCategory,
        };
        const allSmartFields = await InterviewV2API.getMessageTemplateSmartFields(params);
        form.smartFields = allSmartFields.filter(field => field.code !== 'video_interview_link' && field.code !== 'interviewers_names');
    }

    form.onMessageTemplateChange = function (messageTemplate) {

        if (messageTemplate && messageTemplate.message) {
            form.data.message = messageTemplate.message;
        } else {
            form.data.message = defaultMessage;
        }
    };

    form.onDateSelected = function (day) {

        var dayIndex = form.data.selectedEvents.findIndex(function (event) {
            return moment(day).format("DD-MM-YYYY") === moment(event.start).format("DD-MM-YYYY");
        });

        if (dayIndex > -1) {
            form.data.selectedEvents.splice(dayIndex, 1);
        } else {
            form.data.selectedEvents.push({
                start: moment(day).clone().startOf('day').toDate(),
                date: moment(day).toDate(),
                from: moment(day).toDate(),
                to: moment(day).add(1, 'hour').toDate(),
                isSelectable: true
            });
        }

        form.data.selectedEvents.sort(function (slot1, slot2) {
            return moment(slot1.start) - moment(slot2.start);
        });

        form.simpleCalendarTriggers.render && form.simpleCalendarTriggers.render();
    };

    form.openManageMessageTemplatesModal = function () {
        $modal({
            controller: 'ManageLaneTemplatesModal',
            templateUrl: '../modules/ams/modals/manage_lane_templates/manage_lane_templates_modal.html',
            show: true,
            backdrop: 'static',
            resolve: {
                modalData: function () {
                    return {
                        brandId: hUser.getUserContext().brand_id,
                        interviewTemplate: true,
                        interviewCategory: 'IN_PERSON',
                        interviewType: ['INVITE', 'SECOND_INVITE'],
                    };
                },
                onClose: function () {
                    return function (messageTemplates) {
                        form.messageTemplates = messageTemplates.map(function(template) {
                            return {
                                title: template.name,
                                id: template.id,
                                message: template.message
                            }
                        });
                    }
                }
            }
        });
    };

    form.clearAllSelectedLocations = function (filterdLocations) {

        var brands = filterdLocations || form.brands;

        for (var i in brands) {
            form.brands[i].selected = false;
        }

        setTimeout(function () {
            $("." + formName + " [name='brands-pool']:first input[type='checkbox']").change();
        }, 100);
    };

    form.selectAllLocations = function (filterdLocations) {

        var brands = filterdLocations || form.brands;

        for (var i in brands) {
            form.brands[i].selected = true;
        }

        setTimeout(function () {
            $("." + formName + " [name='brands-pool']:first input[type='checkbox']").change();
        }, 100);
    };

    form.save = function () {

        var defer = $q.defer();

        if (form.validator.validate()) {

            form.saving = true;

            var data = {};

            if (!loadedOpenday) {
                data.type = "OPEN_DAY";
            }

            data.title = form.data.title;
            data.message = {
                message: form.data.message
            };

            if (loadedOpenday) {
                data.message.id = loadedOpenday.message.id;
            }

            data.brand_pool = [];

            if (form.data.interviewers.length) {
                data.interviewers = form.data.interviewers.map(function (interviewer) {
                    return {
                        user_id: interviewer.user.id
                    };
                });
            }

            if (form.data.location && form.data.location.google_place_id === form.CUSTOM_LOCATION.google_place_id) {
                data.location = {
                    google_place_id: form.data.custom_location.value.result.place_id,
                    formatted_address: form.data.custom_location.value.result.formatted_address,
                    longitude: form.data.custom_location.value.result.geometry.location.lng,
                    latitude: form.data.custom_location.value.result.geometry.location.lat
                }
            } else {
                data.location = {
                    google_place_id: form.data.location.google_place_id,
                    formatted_address: form.data.location.name,
                    longitude: form.data.location.longitude,
                    latitude: form.data.location.latitude
                }
            }

            if (form.data.selectedEvents && form.data.selectedEvents.length) {
                data.slots = form.data.selectedEvents.map(function (event) {
                    return {
                        start_time: event.from,
                        end_time: event.to
                    }
                });
            }

            for (var i in form.brands) {

                if (form.brands[i].selected) {
                    data.brand_pool.push(form.brands[i].id)
                }
            }

            if (loadedOpenday) {
                InterviewV2API.updateOpenday(hUser.getUserContext().brand_id, loadedOpenday.id, data)
                    .then(function () {
                        form.saving = false;
                        defer.resolve(data);
                        scope.$digest()
                    });
            } else {
                InterviewV2API.addOpenday(hUser.getUserContext().brand_id, data)
                    .then(function () {
                        form.saving = false;
                        defer.resolve(data);
                        scope.$digest();
                    });
            }

        } else {
            defer.reject();
        }

        return defer.promise;

    };

    form.load = async (opendayId, canManageInterviewTemplates) => {
        form.canManageInterviewTemplates = canManageInterviewTemplates;
        form.data.interviewers = [];
        form.data.location = {};
        form.data.title = '';
        await getSmartFields();
        form.data.message = angular.copy(defaultMessage);

        form.data.selectedEvents.splice(0, form.data.selectedEvents.length);

        form.interviewers = angular.copy(allInterviewers);

        form.clearAllSelectedLocations();

        if (opendayId) {

            InterviewV2API.getOpenday(hUser.getUserContext().brand_id, opendayId)
                .then(function (response) {

                    fullPromise = fullPromise.then(function () {
                        loadedOpenday = response.interview_set;

                        form.data = {
                            title: loadedOpenday.title,
                            selectedEvents: form.data.selectedEvents,
                            message: loadedOpenday.message && loadedOpenday.message.message,
                            interviewers: loadedOpenday.interviewers.map(function (interviewer) {
                                return {
                                    id: interviewer.user_id,
                                    name: interviewer.user.first_name + ' ' + interviewer.user.last_name,
                                    user: interviewer.user
                                }
                            })
                        };

                        form.anyConfirmedSlots = _.some(loadedOpenday.slots, function (slot) {
                            return slot.has_confirmed_applications;
                        });

                        for (var i in loadedOpenday.slots) {

                            form.data.selectedEvents.push({
                                date: moment(loadedOpenday.slots[i].start_time).toDate(),
                                from: moment(loadedOpenday.slots[i].start_time).toDate(),
                                to: moment(loadedOpenday.slots[i].end_time).toDate(),
                                start: moment(loadedOpenday.slots[i].start_time).toDate(),
                                isSelectable: !loadedOpenday.slots[i].has_confirmed_applications,
                                uneditable: loadedOpenday.slots[i].has_confirmed_applications
                            });

                            form.data.selectedEvents.sort(function (slot1, slot2) {
                                return moment(slot1.start) - moment(slot2.start);
                            });
                        }

                        form.data.location = form.locations.find(function (loc) {
                            return loc.google_place_id === loadedOpenday.location.google_place_id;
                        });

                        if (!form.data.location) {

                            form.data.location = {
                                google_place_id: loadedOpenday.location.google_place_id,
                                latitude: loadedOpenday.location.latitude,
                                longitude: loadedOpenday.location.longitude,
                                name: loadedOpenday.location.formatted_address
                            };

                            form.locations.push(form.data.location);
                        }

                        for (var i in form.brands) {

                            for (var j in loadedOpenday.brands_pool) {

                                if (loadedOpenday.brands_pool[j].brand_id == form.brands[i].id) {
                                    form.brands[i].selected = true;
                                }
                            }
                        }

                        for (var i in form.data.interviewers) {

                            var interviewerIndex = form.interviewers.findIndex(function (interviewer) {
                                return interviewer.id == form.data.interviewers[i].id;
                            });

                            if (interviewerIndex > -1) {
                                form.interviewers.splice(interviewerIndex, 1);
                            }

                        }

                        form.simpleCalendarTriggers.render && form.simpleCalendarTriggers.render();
                        scope.$digest();
                    });
                })
        } else {
            loadedOpenday = undefined;
            form.data.location = form.locations && form.locations[0];
            form.simpleCalendarTriggers.render && form.simpleCalendarTriggers.render();
        }

    };

    form.validator.validateCustom = function (field, optionsField, rule, showError) {
        var value = form.validator.getFieldValue(field);

        switch (rule.name) {
            case 'validate-data-length':
                if (!form.data[rule.params[0]] || !form.data[rule.params[0]].length) {
                    return false;
                }
                break;

            case "required-fields":
                form.messingRequiredFields = [];
                for (let i in form.smartFields) {
                    let field = form.smartFields[i];
                    if (field.necessity === "REQUIRED" && value.indexOf(field.code) === -1) {
                        form.messingRequiredFields.push(field);
                    }
                }
                if (form.messingRequiredFields.length) {
                    return false;
                }
                break;
        }

        return true;
    };


    /**
     * Load interviewers list
     */
    requiredApisPromise.push(BrandAPI.getBrandInterviewers(hUser.getUserContext().brand_id, true)
        .then(function (response) {
            form.interviewers = response.users.map(function(emp) {
                return {
                    id: emp.id,
                    name: emp.first_name + ' ' + emp.last_name,
                    user: emp
                };
            });

            allInterviewers = angular.copy(form.interviewers);
        }));

    /**
     * Load brands list
     */
    requiredApisPromise.push(BrandAPI.getLocations(hUser.getUserContext().brand_id, true)
        .then(function (brands) {
            form.brands = brands;
        }));

    /**
     * Load Brand message templates list
     */
    requiredApisPromise.push(InterviewV2API.getBrandMessageTemplates(hUser.getUserContext().brand_id, ['INVITE', 'SECOND_INVITE'], 'IN_PERSON')
        .then(function (templates) {
            form.messageTemplates = templates.message_templates;
        }));

    requiredApisPromise.push(AMSAPI.getInterviewLocations(hUser.getUserContext().brand_id)
        .then(function (locations) {
            form.locations = locations.map(function (loc) {
                return {
                    name: loc.formatted_address,
                    google_place_id: loc.google_place_id,
                    longitude: loc.longitude,
                    latitude: loc.latitude
                };
            }).concat(form.CUSTOM_LOCATION);
        }));

    fullPromise = $q.all(requiredApisPromise)
        .then(function () {

            scope.$digest();
        });

    const defaultMessage = `${$filter("translate")("Hello")} {candidate_first_name},\n\n${$filter("translate")("Congratulations")}! {brand_name} ${$filter("translate")("would like to invite you to an interview for the")} {job_position} ${$filter("translate")("position")}. ${$filter("translate")("Schedule a time and date for your interview by clicking below")}. ${$filter("translate")("Your interview will be held at")} {interview_location}.\n\n{interview_link}`;
};

    angular
        .module('harriApp.interviewV2')
        .service('OpenDayDetailsForm', [
            'hUser', '$modal', '$filter',
            function (hUser, $modal, $filter) {

                return function (scope) {
                    return new OpenDayDetailsForm(scope, hUser, $modal, $filter);
                }
            }]);

})();
